import {incrementQuestionCounter} from "./increment-question-counter.js";
import {removeChildren} from "./remove-children.js";
export const renderQuestion = (formElement, response) => {
  const answerWrapper = formElement.querySelector(".quiz-form__answer-wrapper");
  const questionWrapper = formElement.querySelector(".quiz-form__question-text");
  removeChildren(questionWrapper);
  questionWrapper.innerHTML = response.nextQuestion.text;
  for (const answer of response.nextQuestion.answers) {
    const button = document.createElement("button");
    button.innerText = answer.text;
    button.classList.add("quiz-form__answer");
    button.classList.add("headline--3");
    const buttonPressCallback = () => {
      const answerField = formElement.querySelector("input.quiz-form__field-answer");
      answerField.value = answer.uid.toString();
    };
    button.addEventListener("click", buttonPressCallback);
    answerWrapper.appendChild(button);
  }
  incrementQuestionCounter(formElement);
};
